import RtcZego from 'widgets/lib/rtc/rtc-zego';
import RtcAgora from 'widgets/lib/rtc/rtc-agora';
import { useRtcStore, getRtcStore } from 'widgets/lib/rtc/store';
import { useEffect } from 'react';
import {
  RtcType,
  IOptions,
  RoomTypeName,
  IRtcBase,
} from 'widgets/lib/rtc/rtc-base';
import { getStore, useClientRoomStore } from 'client/pc/store';
import performanceStore from 'client/widgets/functions/popup-performance/store';
import { user } from 'lib';
import { getRoomId } from 'client/pc/lib/room';

const getOptions = (): IOptions => {
  return {
    roomId: `${getRoomId()}`,
    userId: `${user.getUserId() || 0}`,
    nickName: user.getUserInfo()?.nick_name ?? '',
    roomTypeName: RoomTypeName.pcClientRoom,
    streamId: `${user.getUserId()}`,
    onPublishStateUpdate: (isPublishing) => {
      getRtcStore().currentRtcInfo.updatePublishingStream(isPublishing);
    },
    onPublishQualityUpdate: (params) => {
      const { videoBitrate, audioBitrate, videoFPS, videoTransferFPS } = params;
      performanceStore.store.updateVideoInfo({
        fps: videoTransferFPS,
        bitrate: videoBitrate,
        lostRate: videoFPS - videoTransferFPS,
      });
    },
    onStopPublishingStream: () => {
      getRtcStore().currentRtcInfo.updatePublishingStream(false);
    },
    onInitMusicInstance: (status) => {
      getStore().room.updateMusicInstance(status);
    },
    onDestroy: () => {
      getRtcStore().currentRtcInfo.updatePublishingStream(false);
    },
  };
};

export const rtcZego = new RtcZego();
export const rtcAgora = new RtcAgora();

export const getCurrentRtc = (rtcType?: string): IRtcBase => {
  return {
    zego: rtcZego,
    agora: rtcAgora,
  }[rtcType || getRtcStore().rtcType]!;
};

export const useRtc = () => {
  const { rtcType, resetRtcZego, resetRtcAgora } = useRtcStore();
  const {
    room: { isRoomOwner },
  } = useClientRoomStore();
  // useEffect(() => {
  //   // if (isRoomOwner) {
  //   //   rtcZego.init(getOptions());
  //   //   return () => {
  //   //     rtcZego.destroy();
  //   //   };
  //   // }
  //   if (isRoomOwner) {
  //     rtcAgora.init(getOptions());
  //     return () => {
  //       rtcAgora.destroy();
  //     };
  //   }
  //   return () => {};
  // }, [isRoomOwner]);
  useEffect(() => {
    if (isRoomOwner) {
      if (rtcType === RtcType.zego) {
        rtcZego.init(getOptions());
        return () => {
          resetRtcZego();
          rtcZego.destroy();
        };
      }
      if (rtcType === RtcType.agora) {
        rtcAgora.init(getOptions());
        return () => {
          resetRtcAgora();
          rtcAgora.destroy();
        };
      }
    }
    return () => {};
  }, [rtcType, isRoomOwner]);
};
